import { Segments } from '../segments.types';

interface SegmentsConfigParams {
    segment: Segments,
    platform: string,
    clientId: string|number,
}

export const configCreateOrUpdateSegments = ({
    segment,
    platform,
    clientId,
}: SegmentsConfigParams) => {
    const { id, name } = segment;
    const data = {
        id,
        name,
        platform,
        client_id: clientId,
        is_fb_tagged_level_adset: false,
        tagged_campaigns: Object.values(segment.taggedCampaigns),
    };
    const isCreating = !id;
    const method = isCreating ? 'POST' : 'PUT';

    return ({
        url: '/api/segments',
        method,
        data,
    });
};
